import styled from './listapedidos.module.css';
import api from '../../services/api';
import { useContext, useEffect, useState } from 'react';
import { Alerta } from '../../utils/functions';
import Pagination from 'react-paginate';
import '../../utils/pagination.css';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../services/global';
import { CiSearch, CiFilter } from 'react-icons/ci';
import { Loader } from '../Loader';


function ListaPedidos() {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const [pedidos, setPedidos] = useState([]);
    const [datas, setDatas] = useState([]);
    const Navigate = useNavigate('');
    const { setDadosPed,filtro,tipo } = useContext(AuthContext);
    const [tipfil, setTipfil] = useState(tipo);
    const [fil1, setFil1] = useState('');
    const [fil2, setFil2] = useState('');
    const [fil3, setFil3] = useState('0');
    const [fil4, setFil4] = useState(filtro);
    const [isLoading, setLoading] = useState(false);
    const [filtersitua, setFiltersitua] = useState(false);

    const itemPerPage = 6;
    const [currentPage, setCurrentPage] = useState(0);

    //Logica para Paginação
    const pages = (Math.ceil(datas.length / itemPerPage));
    const startIndex = currentPage * itemPerPage;
    const endtIndex = startIndex + itemPerPage;

    const currentItens = (datas.slice(startIndex, endtIndex));

    function ShowFilter() {
        setFiltersitua(!filtersitua);
    }

    function Limpar() {
        setTipfil('3');
        setFil1('');
        setFil2('');
        setFil3('0');
        setFil4('Todos');
        setFiltersitua(false);
    }

    const PageClick = (event) => {
        setCurrentPage(event.selected);
    };

    //Função para gravar dados a serem usados na page detalhes
    function DetalhePedido(wnumped) {
        let temp = [];
        pedidos.filter(pedido => pedido.numped == wnumped).map((item) => {
            temp.push({
                numped: item.numped,
                ordem: item.talcli,
                data: item.datped,
                valor: item.valven,
                status: item.status,
                datent: item.datent,
                numnot: item.numnot,
                page: "/pedidos"
            })
        })
        setDadosPed(temp);

        Navigate('/DetPedido');
    }


    function Filtro(wtipfil, wvalue) {
        if (wvalue.length == 0 && wtipfil != 3) {
            setTipfil('3')
        } else {


            if (wtipfil == '1') {
                setTipfil('1');
                //setFil1(wvalue);
            }
            if (wtipfil == '2') {
                setTipfil('2');
                //setFil2(wvalue);
            }
            if (wtipfil == '3') {
                setFil1('');
                setFil2('');
                setFil3(wvalue);
                setTipfil('3');

            }
            if (wtipfil == '4') {
                setFil1('');
                setFil2('');
                setFil4(wvalue);
                setTipfil('4');

            }

        }
    }


    function GetPedidos() {
        setLoading(true);

        let temp = [];
        let data = [];
        let datafim = [];

        api.get(`pedidos/lista/?cgccli=${cgccli}&tipfil=${tipfil}&fil1=${fil1}&fil2=${fil2}&fil3=${fil3}&fil4=${fil4}`)
            .then((response) => {
                if (!response.data.msg) {

                    temp = response.data;
                    temp.map((item) => {
                        if (data.indexOf(item.datped) < 0) {
                            data.push(
                                item.datped
                            )
                        }
                    })

                    data.map((item) => {
                        datafim.push({
                            datped: item
                        })
                    })

                    setDatas(datafim);
                    setPedidos(response.data);
                    setCurrentPage(0);
                    setLoading(false);

                } else {
                    setLoading(false);
                    Alerta('Erro!', response.data.msg, 'error');
                }
            }).catch((erro) => {
                //Alerta('Erro!', 'Servidor sem resposta', 'error');
                setTimeout(function() {
                    window.location.reload(true);
                  }, 5000); // 5 segundos
            })
    }

    useEffect(() => {   
        GetPedidos();
        
    }, [tipfil, fil3, fil4])



    return (
        <>
            <div className={styled.diviconfilter} onClick={() => ShowFilter()}>
                <CiFilter size={28} />
                <span>Filtros</span>
            </div>

            {(filtersitua == true) || (window.screen.availWidth >= 1024) ?
                <div className={styled.divfiltros}>
                    <div className={styled.divfiltro1}>
                        <a>Nº DO PEDIDO</a>
                        <div className={styled.input}>

                            <input type='text' placeholder='Pesquisar' value={fil1} onChange={(e) => setFil1(e.target.value)} />
                            <CiSearch onClick={() => Filtro('1', fil1)} className={styled.divfiltro1icon} />
                        </div>
                    </div>
                    <div className={styled.divfiltro1}>
                        <a>NOTA FISCAL</a>
                        <div className={styled.input}>

                            <input type='text' placeholder='Pesquisar' value={fil2} onChange={(e) => setFil2(e.target.value)} />
                            <CiSearch onClick={() => Filtro('2', fil2)} className={styled.divfiltro1icon} />
                        </div>
                    </div>
                    <div className={styled.divfiltro1}>
                        <a>EXIBIR PEDIDOS DE</a>
                        <div className={styled.select}>
                            <select name="data" id="data" onChange={(e) => Filtro('3', e.target.value)}>
                                <option value="0">Até 1 ano atrás</option>
                                <option value="1">Até 2 anos atrás</option>
                                <option value="2">Até 3 anos atrás</option>
                            </select>
                        </div>
                    </div>
                    <div className={styled.divfiltro1}>
                        <a>STATUS DO PEDIDO</a>
                        <div className={styled.select}>
                            <select name="data" id="data"  onChange={(e) => Filtro('4', e.target.value)}>
                                <option value="TODOS">Todos</option>
                                <option value="EM ANALISE">Em Analise</option>
                                <option value="PRODUZINDO">Produzindo</option>
                                <option value="EM TRANSPORTE">Em Transporte</option>
                                <option value="ENTREGUE">Entregue</option>
                            </select>
                        </div>
                    </div>
                    <div className={styled.divfiltro2}>
                        <div onClick={() => Limpar()} className={styled.btnlimpa}>
                            Limpar Filtros
                        </div>
                    </div>
                </div> : null}



            <div className={styled.appultimospedidos}>
                <div className={styled.frame99}>
                    {isLoading == true ? <Loader /> : <>
                        {
                            currentItens.map((dat) => {

                                return (
                                    <>
                                        <div className={styled.appitem}>
                                            <a>Solicitado em <span>{dat.datped}</span></a>
                                            <div className={styled.appitemgrupo}>
                                                {pedidos.filter(pedido => pedido.datped == dat.datped).map((item) => {
                                                    return (
                                                        <div key={item.numped} onClick={() => DetalhePedido(item.numped)} className={styled.appitempedido}>

                                                            <div className={styled.pedidocontent}>
                                                                <div className={styled.pedidocontent0}>
                                                                    <a>Nº <span>{item.numped}</span></a>
                                                                    <a>O.C {item.talcli}</a>
                                                                    <a>N.F {item.numnot}</a>
                                                                </div>
                                                                <div className={styled.pedidocontent1}>
                                                                    <a>{item.valven.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</a>
                                                                    <div className={styled.statusdiv}>
                                                                        <div className={styled.tagstatus}>
                                                                            {item.status == 'EM TRANSPORTE' ? <div className={styled.statustrans}></div> : null}
                                                                            {item.status == 'PRODUZINDO' ? <div className={styled.statusprod}></div> : null}
                                                                            {item.status == 'ENTREGUE' ? <div className={styled.statusentregue}></div> : null}
                                                                            {item.status == 'PEDIDO RECEBIDO' ? <div className={styled.statusrecebido}></div> : null}
                                                                            {item.status == 'EM ANALISE' ? <div className={styled.statusanalise}></div> : null}
                                                                            <a>{item.status}</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}

                                            </div>
                                        </div>

                                    </>
                                )
                            })
                        }
                    </>
                    }
                    < div className={styled.paginate}>
                        <Pagination
                            breakLabel="..."
                            nextLabel=">>"
                            onPageChange={PageClick}
                            pageCount={pages}
                            previousLabel="<<"
                            renderOnZeroPageCount={null}
                            containerClassName={'pagination'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                            activeClassName={'active'}
                            forcePage={currentPage}
                        />
                    </div>



                </div>

            </div>
        </>

    )
}


export default ListaPedidos;